/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Artist } from '../models/Artist';
import type { IdAndSlug } from '../models/IdAndSlug';
import { request as __request } from '../core/request';

export class AdminService {

    /**
     * Get Artist Ids Split
     * @result IdAndSlug Successful Response
     * @throws ApiError
     */
    public static async getArtistIdsSplit(): Promise<Array<IdAndSlug>> {
        const result = await __request({
            method: 'GET',
            path: `/admin/get_artist_ids_split`,
        });
        return result.body;
    }

    /**
     * Get Artist Ids
     * @param limit
     * @param lastDocId
     * @result IdAndSlug Successful Response
     * @throws ApiError
     */
    public static async getArtistIds({
        limit,
        lastDocId,
    }: {
        limit?: number,
        lastDocId?: string,
    }
): Promise<Array<IdAndSlug>> {
    const result = await __request({
        method: 'GET',
        path: `/admin/get_artist_ids`,
        query: {
            'limit': limit,
            'last_doc_id': lastDocId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

/**
 * Get Artists
 * @param limit
 * @param lastDocId
 * @result Artist Successful Response
 * @throws ApiError
 */
public static async getArtists({
    limit,
    lastDocId,
}: {
    limit?: number,
    lastDocId?: string,
}
): Promise<Array<Artist>> {
    const result = await __request({
        method: 'GET',
        path: `/admin/get_artists`,
        query: {
            'limit': limit,
            'last_doc_id': lastDocId,
        },
        errors: {
            422: `Validation Error`,
        },
    });
    return result.body;
}

}